{
  "name": "ziptility",
  "version": "1.62.0",
  "private": true,
  "repository": "https://github.com/Ziptility/ziptility-web",
  "main": "main.js",
  "scripts": {
    "start:local": "ng serve -c=local",
    "start:staging": "ng serve -c=staging",
    "start:prod": "ng serve -c=production",
    "start:debugProd": "ng serve -c=localProd",
    "build:local": "ng build -c=local",
    "build:staging": "ng build -c=staging",
    "build:prod": "ng build -c=production",
    "test": "TZ=UTC npx jest --verbose",
    "test:ci": "TZ=UTC npx jest --ci",
    "test:coverage": "TZ=UTC npx jest --coverage=true",
    "lint": "eslint ./src --ext ts",
    "deploy:staging": "./deploy/deploy.staging.sh",
    "deploy:prod": "./deploy/deploy.prod.sh",
    "deploy:appAssociation": "./deploy/apple.app.site.association.sh",
    "postinstall": "husky install",
    "generate:schema": "graphql-codegen --config graphql-codegen-config.yml",
    "generate:sprites": "node scripts/sprites/build.js",
    "version": "echo $npm_package_version",
    "release": "release-it",
    "release:ci": "release-it --ci",
    "release:dry": "release-it --dry-run",
    "semantic-release": "semantic-release",
    "typecheck": "tsc --noEmit",
    "prepare": "husky install",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org ziptility --project frontend ./dist && sentry-cli sourcemaps upload --release $npm_package_version --org ziptility --project frontend ./dist"
  },
  "dependencies": {
    "@angular-devkit/build-angular": "^21.1.1",
    "@angular/animations": "^21.1.1",
    "@angular/cdk": "^21.1.1",
    "@angular/cli": "^21.1.1",
    "@angular/common": "^21.1.1",
    "@angular/compiler": "^21.1.1",
    "@angular/compiler-cli": "^21.1.1",
    "@angular/core": "^21.1.1",
    "@angular/forms": "^21.1.1",
    "@angular/material": "^21.1.1",
    "@angular/platform-browser": "^21.1.1",
    "@angular/platform-browser-dynamic": "^21.1.1",
    "@angular/platform-server": "^21.1.1",
    "@angular/router": "^21.1.1",
    "@apollo/client": "^4.0.1",
    "@graphql-codegen/cli": "^5.0.6",
    "@graphql-codegen/typescript": "^4.1.6",
    "@graphql-codegen/typescript-apollo-angular": "^4.0.0",
    "@graphql-codegen/typescript-operations": "^4.6.1",
    "@mapbox/mapbox-gl-draw": "^1.5.0",
    "@mapbox/mapbox-gl-geocoder": "^5.0.2",
    "@mapbox/mapbox-sdk": "^0.15.5",
    "@microsoft/signalr": "^9.0.6",
    "@ng-select/ng-select": "^21.2.0",
    "@ngrx/component-store": "^21.0.1",
    "@ngrx/effects": "^21.0.1",
    "@ngrx/signals": "^21.0.1",
    "@ngrx/store": "^21.0.1",
    "@sentry/angular": "^10.2.0",
    "@statsig/angular-bindings": "^3.31.2",
    "@statsig/client-core": "^3.31.2",
    "@statsig/js-client": "^3.31.2",
    "@testing-library/dom": "^10.4.1",
    "@testing-library/user-event": "^14.6.1",
    "@turf/turf": "^6.5.0",
    "@types/pdfjs-dist": "^2.1.7",
    "@typescript-eslint/eslint-plugin": "^8.53.1",
    "@typescript-eslint/parser": "^8.53.1",
    "angular-feather": "^6.5.1",
    "angular-imask": "^6.4.2",
    "apollo-angular": "^13.0.0",
    "babel-jest": "^30.2.0",
    "core-js": "^3.21.1",
    "eslint-plugin-jest": "^24.3.1",
    "graphql": "^16",
    "lodash": "^4.17.11",
    "mapbox-gl": "^3.11.1",
    "marked": "^17.0.0",
    "moment": "^2.22.2",
    "ng2-cookies": "^1.0.4",
    "ng2-pdf-viewer": "^10.0.0",
    "ngrx-store-localstorage": "^20.0.0",
    "ngx-clipboard": "^16.0.0",
    "ngx-infinite-scroll": "^21.0.0",
    "ngx-mapbox-gl": "^14.0.0",
    "ngx-markdown": "^21.0.1",
    "ngx-moment": "^6.0.2",
    "pluralize": "^8.0.0",
    "reflect-metadata": "^0.1.3",
    "rxjs": "^7.6.0",
    "tslib": "^2.0.0",
    "uuid": "^11.1.0",
    "xlsx": "^0.18.5",
    "zone.js": "^0.15.0"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^21.1.0",
    "@angular-eslint/eslint-plugin": "^21.1.0",
    "@angular-eslint/eslint-plugin-template": "^21.1.0",
    "@angular-eslint/schematics": "^21.1.0",
    "@angular-eslint/template-parser": "^21.1.0",
    "@release-it/conventional-changelog": "^10.0.5",
    "@tailwindcss/aspect-ratio": "^0.4.2",
    "@tailwindcss/forms": "^0.5.7",
    "@tailwindcss/line-clamp": "^0.4.4",
    "@tailwindcss/typography": "^0.5.10",
    "@testing-library/angular": "^18.1.0",
    "@testing-library/jest-dom": "^6.9.1",
    "@types/jest": "^30.0.0",
    "@types/lodash": "^4.14.136",
    "@types/mapbox-gl": "^3.4.1",
    "@types/marked": "^4.3.0",
    "@types/node": "^12.20.55",
    "autoprefixer": "^10.4.17",
    "aws-sdk": "^2.270.1",
    "conventional-changelog-angular": "^8.1.0",
    "eslint": "^9.26.0",
    "husky": "^8.0.3",
    "jest": "^30.2.0",
    "jest-environment-jsdom": "^30.2.0",
    "jest-preset-angular": "^16.0.0",
    "jsonlint-lines": "^1.7.1",
    "mime": "^1.3.4",
    "ng-packagr": "^21.1.0",
    "postcss": "^8.4.35",
    "postcss-loader": "^2.0.5",
    "pre-commit": "^1.2.2",
    "prettier": "^3.1.1",
    "raw-loader": "^0.5.1",
    "recursive-readdir": "2.1.1",
    "release-it": "^19.2.4",
    "sass-loader": "^7.1.0",
    "semantic-release": "^19.0.5",
    "spritesmith": "^3.5.1",
    "tailwindcss": "^3.4.1",
    "ts-jest": "^29.1.1",
    "ts-loader": "^3.3.0",
    "typescript": "5.9.3"
  },
  "optionalDependencies": {
    "@rollup/rollup-linux-x64-gnu": "*",
    "fsevents": "^2.0.7"
  }
}
